// Local translations — the copy is screen 05 of the QL-375 design.
export const T = {
  en_GB: {
    title: "Mandate templates",
    description:
      "A mandate template is a permitted allocation offered for a risk score in this collection — ISINs and weights, nothing more. It is tagged to the platforms it serves, exactly as products and model portfolios are. Where several match a goal the advisor picks one; where exactly one matches it is applied automatically.",
    addTemplate: "Add template",
    noTemplates: 'No mandate templates yet. Click "Add template" to create one.',
    riskScore: "Risk score",
    template: "Template",
    platforms: "Platforms",
    notTagged: "Not tagged",
    mode: "Mode",
    modeFixed: "Fixed weights",
    modeMinMax: "Min/max weights",
    instruments: "Instruments",
    active: "Active",
    actions: "Actions",
    edit: "Edit template",
    delete: "Delete",
    deleteTitle: "Delete template",
    deleteDescription:
      "Are you sure you want to delete this template? Completed advice keeps its copy. Goals on open advice that use it are re-resolved: they pick another matching template or lose the mandate.",
    cancel: "Cancel",
    error: "Error",
    failedToToggle: "Failed to update the template",
    failedToDelete: "Failed to delete the template",
    failedToTranslate: "Failed to save the translation",
    scoresWithoutTemplate: (scores: string) => `Risk scores with no active template: ${scores}.`,
    untagged: (names: string) =>
      `${names} tagged to no platform — unavailable to every goal with a platform, the same rule products and model portfolios follow.`,
    inactiveProduct: (names: string) =>
      `${names} list an inactive product — that line cannot be held.`,
  },
  nb_NO: {
    title: "Mandatmaler",
    description:
      "En mandatmal er en tillatt allokering som tilbys for en risikoscore i denne samlingen — ISIN-er og vekter, ikke noe mer. Den merkes med plattformene den gjelder for, akkurat som produkter og modellporteføljer. Der flere passer til et mål velger rådgiveren én; der nøyaktig én passer brukes den automatisk.",
    addTemplate: "Legg til mal",
    noTemplates: "Ingen mandatmaler ennå. Klikk «Legg til mal» for å opprette en.",
    riskScore: "Risikoscore",
    template: "Mal",
    platforms: "Plattformer",
    notTagged: "Ikke merket",
    mode: "Modus",
    modeFixed: "Faste vekter",
    modeMinMax: "Min/maks-vekter",
    instruments: "Instrumenter",
    active: "Aktiv",
    actions: "Handlinger",
    edit: "Rediger mal",
    delete: "Slett",
    deleteTitle: "Slett mal",
    deleteDescription:
      "Er du sikker på at du vil slette denne malen? Fullførte råd beholder sin kopi. Mål i åpne råd som bruker den, utledes på nytt: de får en annen passende mal eller mister mandatet.",
    cancel: "Avbryt",
    error: "Feil",
    failedToToggle: "Kunne ikke oppdatere malen",
    failedToDelete: "Kunne ikke slette malen",
    failedToTranslate: "Kunne ikke lagre oversettelsen",
    scoresWithoutTemplate: (scores: string) => `Risikoscore uten aktiv mal: ${scores}.`,
    untagged: (names: string) =>
      `${names} er ikke merket med noen plattform — utilgjengelig for alle mål med plattform, samme regel som produkter og modellporteføljer følger.`,
    inactiveProduct: (names: string) =>
      `${names} inneholder et inaktivt produkt — den linjen kan ikke eies.`,
  },
} as const;
